// @flow

import React from 'react';
import styled from 'styled-components';
import Chevron from './chevron.svg';
import { svgEncode } from '../../../../helpers';
import type { Theme } from '../../../../types';

type ListItemProps = {
  isVisible: boolean;
};

const ListItem = styled<any, Theme, ListItemProps>('article')`
  background-color: ${props => props.theme.faq.questionList.backgroundColor};
  border-radius: 4px;
  margin-bottom: 0.25rem;
  padding: 1rem 3rem 1rem 1rem;
  position: relative;
  width: auto;

  &:hover {
    background-color: ${props => props.theme.faq.questionList.backgroundColorHover};
  }

  &::after {
    background-image: url('data:image/svg+xml;utf8,${svgEncode(Chevron)}');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 1em auto;
    content: '';
    display: block;
    height: 1.5rem;
    position: absolute;
    right: 1rem;
    top: 1rem;
    transform: rotate(${props => (props.isVisible ? '-90deg' : '90deg')});
    transform-origin: center;
    width: 1.5rem;
  }
`;

const ListHeader = styled<any, Theme>('header')`
  color: ${props => props.theme.faq.questionList.question.color};
  font-weight: ${props => props.theme.faq.questionList.question.fontWeight};
  font-size: 1.125rem;
`;

const ListContent = styled<any, Theme>('section')`
  margin-top: .5rem;
  white-space: pre-line;
`;

type Props = {|
  toggleItem: Function,
  isVisible: boolean,
  question: string,
  answer: string,
|};

const CategoryAccordionItem = ({
  question, answer, isVisible, toggleItem,
}: Props) => (
  <ListItem onClick={toggleItem} isVisible={isVisible}>
    <ListHeader>{question}</ListHeader>
    {isVisible && <ListContent dangerouslySetInnerHTML={{ __html: answer }} />}
  </ListItem>
);

export default CategoryAccordionItem;
